import { GetterTree } from 'vuex';

import { StateType } from './state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const moduleGetters: GetterTree<StateType, any> = {
  getLocale(state) {
    return state.language?.locale;
  },
};

export default moduleGetters;
